import axios from 'axios'
import { setupCache } from 'axios-cache-interceptor'
const { url } = window.__REACT_WORDPRESS__.routing

const ajaxCustom = setupCache(
  axios.create({
    baseURL: `${url}/wp-json/custom/v1/`,
  }),
)

export const fetchCustomItems = async ({ type, params = {} }) => {
  return await ajaxCustom.get(`/${type}/`, { params })
}
